import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
    playbook: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

// Keep previously shared links and bookmarks working after the page moves.
export const Route = createFileRoute('/_app/(main)/playbooks')({
    validateSearch: searchSchema,
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/settings/agent-rules',
            search,
            replace: true,
        });
    },
    component: () => null,
});
